import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { localeOf, HTML_LANG, type Locale } from "./registry";

/**
 * Язык текущей страницы (BTQ-47, Этап 1).
 *
 * Определяется исключительно по пути: /pt и всё под ним — португальская
 * сторона, остальное — английская. Ни куки, ни Accept-Language, ни состояния:
 * страница на конкретном адресе обязана выглядеть одинаково для человека, для
 * краулера и для prerender, иначе Google увидит одно, а посетитель другое.
 */
export function useLocale(): Locale {
  return localeOf(useLocation().pathname);
}

/**
 * Держит <html lang> в согласии с языком открытой страницы.
 *
 * В сыром HTML атрибут уже правильный: его пишет prerender (htmlAttributes из
 * Helmet) и дублирует воркер. Но при переходе ВНУТРИ приложения ни то ни другое
 * не участвует, а react-helmet-async атрибуты тега <html> при смене маршрута не
 * снимает и не переставляет — проверено на preview-сборке 22.08.2026: клик по
 * «PT» на английской странице оставлял lang="en" на португальской.
 *
 * Для выдачи это безразлично (краулер читает сырой HTML), но скринридер берёт
 * голос именно отсюда и читал бы португальский текст английским голосом.
 * Поэтому — явный эффект, один на приложение.
 */
export function useSyncHtmlLang(): void {
  const locale = useLocale();
  useEffect(() => {
    const el = document.documentElement;
    if (el.lang !== HTML_LANG[locale]) el.lang = HTML_LANG[locale];
  }, [locale]);
}

/** Монтируется один раз в AppInner — рядом со ScrollToTop. */
export function HtmlLangSync(): null {
  useSyncHtmlLang();
  return null;
}
